export const antwortenF1 = [
    {
      WertGruen: 0,
      WertRot: 0
    },
    {
      Wert1: "+",
      Wert2: "-",
      Wert3: "0",
      WertGruen: -1,
      WertRot: -1
    },
    {
      Wert1: "+",
      Wert2: "0",
      Wert3: "-",
      WertGruen: 0,
      WertRot: -1
    },
    {
      Wert1: "0",
      Wert2: "+",
      Wert3: "-",
      WertGruen: 1,
      WertRot: 0
    },
    {
      Wert1: "-",
      Wert2: "+",
      Wert3: "0",
      WertGruen: 1,
      WertRot: 1
    },
    {
      Wert1: "0",
      Wert2: "-",
      Wert3: "+",
      WertGruen: -1,
      WertRot: 0
    },
    {
      Wert1: "-",
      Wert2: "0",
      Wert3: "+",
      WertGruen: 0,
      WertRot: 1
    }
  ];
   
  export const antwortenF2 = [
    {
      WertGruen: 0,
      WertRot: 0,
    },
    {
      Wert1: "+",
      Wert2: "-",
      Wert3: "0",
      WertGruen: -1,
      WertRot: 0,
    },
    {
      Wert1: "+",
      Wert2: "0",
      Wert3: "-",
      WertGruen: 0,
      WertRot: 1
    },
    {
      Wert1: "0",
      Wert2: "+",
      Wert3: "-",
      WertGruen: 1,
      WertRot: 1
    },
    {
      Wert1: "-",
      Wert2: "+",
      Wert3: "0",
      WertGruen: 1,
      WertRot: 0
    },
    {
      Wert1: "0",
      Wert2: "-",
      Wert3: "+",
      WertGruen: -1,
      WertRot: -1
    },
    {
      Wert1: "-",
      Wert2: "0",
      Wert3: "+",
      WertGruen: 0,
      WertRot: -1,
    }
  ];
  export const antwortenF3 = [
    {
      WertGruen: 0,
      WertRot: 0,
    },
    {
      Wert1: "+",
      Wert2: "-",
      Wert3: "0",
      WertGruen: 1,
      WertRot: 0,
    },
    {
      Wert1: "+",
      Wert2: "0",
      Wert3: "-",
      WertGruen: 1,
      WertRot: 1
    },
    {
      Wert1: "0",
      Wert2: "+",
      Wert3: "-",
      WertGruen: 0,
      WertRot: 1
    },
    {
      Wert1: "-",
      Wert2: "+",
      Wert3: "0",
      WertGruen: -1,
      WertRot: 0
    },
    {
      Wert1: "0",
      Wert2: "-",
      Wert3: "+",
      WertGruen: 0,
      WertRot: -1
    },
    {
      Wert1: "-",
      Wert2: "0",
      Wert3: "+",
      WertGruen: -1,
      WertRot: -1,
    }
  ];

  export const antwortenF4 = [
    {
      WertGruen: 0,
      WertRot: 0,
    },
    {
      Wert1: "+",
      Wert2: "-",
      Wert3: "0",
      WertGruen: 1,
      WertRot: 0,
    },
    {
      Wert1: "+",
      Wert2: "0",
      Wert3: "-",
      WertGruen: 1,
      WertRot: 1
    },
    {
      Wert1: "0",
      Wert2: "+",
      Wert3: "-",
      WertGruen: 0,
      WertRot: 1
    },
    {
      Wert1: "-",
      Wert2: "+",
      Wert3: "0",
      WertGruen: -1,
      WertRot: 0
    },
    {
      Wert1: "0",
      Wert2: "-",
      Wert3: "+",
      WertGruen: 0,
      WertRot: -1
    },
    {
      Wert1: "-",
      Wert2: "0",
      Wert3: "+",
      WertGruen: -1,
      WertRot: -1,
    }
  ];

  export const antwortenF5 = [
    {
      WertGruen: 0,
      WertRot: 0,
    },
    {
      Wert1: "+",
      Wert2: "-",
      Wert3: "0",
      WertGruen: 1,
      WertRot: 0,
    },
    {
      Wert1: "+",
      Wert2: "0",
      Wert3: "-",
      WertGruen: 1,
      WertRot: 1
    },
    {
      Wert1: "0",
      Wert2: "+",
      Wert3: "-",
      WertGruen: 0,
      WertRot: 1
    },
    {
      Wert1: "-",
      Wert2: "+",
      Wert3: "0",
      WertGruen: -1,
      WertRot: 0
    },
    {
      Wert1: "0",
      Wert2: "-",
      Wert3: "+",
      WertGruen: 0,
      WertRot: -1
    },
    {
      Wert1: "-",
      Wert2: "0",
      Wert3: "+",
      WertGruen: -1,
      WertRot: -1,
    }
  ];

  export const antwortenF6 = [
    {
      WertGruen: 0,
      WertRot: 0,
    },
    {
      Wert1: "+",
      Wert2: "-",
      Wert3: "0",
      WertGruen: -1,
      WertRot: -1,
    },
    {
      Wert1: "+",
      Wert2: "0",
      Wert3: "-",
      WertGruen: 0,
      WertRot: -1
    },
    {
      Wert1: "0",
      Wert2: "+",
      Wert3: "-",
      WertGruen: 1,
      WertRot: 0
    },
    {
      Wert1: "-",
      Wert2: "+",
      Wert3: "0",
      WertGruen: 1,
      WertRot: 1
    },
    {
      Wert1: "0",
      Wert2: "-",
      Wert3: "+",
      WertGruen: -1,
      WertRot: 0
    },
    {
      Wert1: "-",
      Wert2: "0",
      Wert3: "+",
      WertGruen: 0,
      WertRot: 1,
    }
  ];

  export const antwortenF7 = [
    {
      WertGruen: 0,
      WertRot: 0,
    },
    {
      Wert1: "+",
      Wert2: "-",
      Wert3: "0",
      WertGruen: -1,
      WertRot: 0,
    },
    {
      Wert1: "+",
      Wert2: "0",
      Wert3: "-",
      WertGruen: 0,
      WertRot: 1
    },
    {
      Wert1: "0",
      Wert2: "+",
      Wert3: "-",
      WertGruen: 1,
      WertRot: 1
    },
    {
      Wert1: "-",
      Wert2: "+",
      Wert3: "0",
      WertGruen: 1,
      WertRot: 0
    },
    {
      Wert1: "0",
      Wert2: "-",
      Wert3: "+",
      WertGruen: -1,
      WertRot: -1
    },
    {
      Wert1: "-",
      Wert2: "0",
      Wert3: "+",
      WertGruen: 0,
      WertRot: -1,
    } 
  ];

  
  export const fragen = ["Stellen Sie sich vor, Sie kommen in eine Gruppe von Menschen, die Ihnen fremd sind. Wie fühlen Sie sich? Welches Verhalten ist für Sie in einer solchen Situation typisch? ", "Nicht immer geht alles reibungslos oder so, wie man es selbst gern hätte. Manchmal gibt es Ärger und Aufregung. Wie ist denn Ihre typische Art, im Beruf oder im Privaten auf Ärger und Aufregung zu reagieren? Gerade im Zustand der Aufregung zeigen sich Züge der Persönlichkeit, die sonst eher zurückgehalten werden.","Die Jahre der Kindheit, danach die Jugendjahre und schließlich das Erwachsenenalter - das sind recht verschiedene Zeit-Welten.","Menschen sind unterschiedlich in der Art, wie sie sich geben. Diese Unterschiede werden von der Umwelt schon als \"erster Eindruck\" wahrgenommen. Bei näherer Bekanntschaft, werden dann weitere Eigenarten deutlich.", "Jeder Mensch hat seine besondere Art, sich seine Zeit einzuteilen.","Wie verbringen Sie Ihre Freizeit, also die Zeit, in der Sie wirklich einmal von allen Pflichten frei sind und tun können, was Sie wollen?","Welche der drei hier aufgeführten Situationen erscheint Ihnen lebenswichtig?","Das waren die ersten sieben Aufgaben, die zunächst einmal die Grundrichtung Ihres Structograms festlegen sollten. Nun folgen drei weitere Aufgaben zu Präzisierung Ihres Structograms. Nebenstehhend finden Sie sechs Aufgaben. Wählen Sie davon die drei Aussagen aus, die am besten auf Sie zutreffen. Sie müssen drei Aussagen auswählen. Eine oder zwei zutreffende Aussagen werden Sie wahrscheinlich leicht finden. Wählen Sie aus dem Rest dann die aus, die noch am ehesten zutreffen, bis Sie drei Aussagen angekreuzt haben. Manchmal geht es leichter umgekehrt. Scheiden Sie die Aussagen aus, die am wenigsten auf Sie zutreffen, bis schließlich drei übrig bleiben.", "Noch eine Aufgabe der gleichen Art. Nebenstehend finden Sie sechs Aufgaben. Wählen Sie davon die drei Aussagen aus, die am besten auf Sie zutreffen.","Hier die letzte Aufgabe gleicher Art. Nebenstehend finden Sie sechs Aufgaben. Wählen Sie davon die drei Aussagen aus, die am besten auf Sie zutreffen."];
  export const fragenZusatz = ["Versuchen sie sich zu erinnern, was Sie bei solchen Gelegenheiten empfanden, vielleicht beim Beginn eines Seminars, bei einer Tagung oder bei einem Empfang, einer privaten Einladung oder einer Party oder als \"Neuer\" an einem Arbeitsplatz.","Gefragt wird hier nicht nach Ausnahmefällen, in denen jedem einmal \"der Kragen platzt\", sondern nach dem ganz alltäglichen Ärger, um den man einfach nicht herumkommen kann.","Welcher dieser Perioden halten Sie für die schönste Zeit?", "Hier geht es um Ihre Wirkung beim ersten Eindruck. Was meinen Sie, wie Ihre Umwelt Sie sieht?", "Wie ist es in dieser Hinsicht bei Ihnen?","", "", "","",""] 
  export const antwortenFrage1 = ["Unter fremden Menschen fühle ich mich oft unbehaglich, ich halte mich zunächst lieber im Hintergrund.", "In geselligem Kreise fühle ich mich sofort sehr wohl, auch zu Fremden finde ich rasch guten Kontakt.", "Ich bin in einer Gruppe oft derjenige der \"das Sagen hat\"; bei Unternehmungen übernehme ich gern die Führung."]; 
  export const antwortenFrage2 = ["Wenn ich mich ärgere \"gehe ich leicht in die Luft\". Am liebsten würde ich mich dann auch körperlich abreagieren.", "Wenn mich etwas ärgert, muss ich mich mitteilen. Ich möchte mir am liebsten alles von der Seele reden.", "Ich lasse mir Ärger und Aufregung möglichst gar nicht anmerken. Ich muss damit allein fertig werden. Am liebsten ziehe ich mich ganz zurück."];
  export const antwortenFrage3 = ["Die Kindheit ist doch eine schöne Zeit, mit ihrer Geborgenheit und Sorglosigkeit. Ich komme gut mit Kindern zurecht, die mögen mich auch sofort.", "Es wäre gut, wenn man die Jugendzeit, in der man die Welt erobert, möglichst lange ausdehnen könnte, denn da kostet man alles so richtig aus.", "Je älter ich werde, um so mehr gewinne ich Abstand und komme dadurch mit mir selbst und mit der Welt besser zurecht."];
  export const antwortenFrage4 = ["Ich wirke gemütlich und gesellig.", "Ich wirke lebhaft und impulsiv.", "Ich wirke still und zurückhaltend."];
  export const antwortenFrage5 = ["Oft vergesse ich die Zeit völlig und komme dadurch zu spät zu Verabredungen und Terminen.", "Termine erreiche ich häufig grade noch in letzter Minute, bei Verabredungen bin ich oft der Letzte.", "Bei Verabredungen und Terminen fürchte ich, mich zu verspäten und komme deshalb aus Vorsicht oft zu früh."];
  export const antwortenFrage6 = ["Am liebsten gehe ich ungestört meinen eigenen Interessen nach.", "Ich faulenze liebend gern oder vertreibe mir die Zeit in netter Gesellschaft.", "Ich muss immer irgendetwas unternehmen, kann nicht lange stillsitzen."];
  export const antwortenFrage7 = ["In engen Räumen eingesperrt, gefesselt oder gar gelähmt zu sein, erscheint mir am unerträglichsten. Bewegungsfreiheit ist mir lebenswichtig.", "Von Kontakten zu Außenwelt abgeschnitten und von den Menschen verlassen zu sein, erscheint mir am unerträglichsten. Kontakte zu Menschen sind mir lebenswichtig.", "Dauernd unter Menschein sein zu müssen und mich nie zurückziehen zu können, erscheint mir am unerträglichsten. Meine \"Privatsphäre\" ist mir lebenswichtig."];
  export const antwortenFrage8 = ["Ich \"rede nicht um den heißen Brei\" herum, bin nicht immer sehr diplomatisch.", "Ich kann meine Gefühle nicht gut zeigen und werde oft nicht richtig eingeschätzt.", "Ich bin sehr an Menschen interessiert, an ihrem Leben und an ihrem Lebensumständen.", "Ich liebe das Risiko und Abenteuer. Mein Motto: \"Wer wagt, gewinnt!\".", "Ich bin sehr empfindlich gegen Lärm, verhalte mich auch selbst meist leise.", "Im Grunde bin ich ein Feinschmecker, denn ich liebe eine gute Küche."];
  export const antwortenFrage9 = ["Ich mag keinen Unfrieden, bin verständnisvoll und ausgleichend.", "Ich bin kurz entschlossen, langes Zögern ist nicht meine Art.", "Ich bin äußerst gewissenhaft, oft auch in Kleinigkeiten.", "Ich mache es mir oft unnötig schwer, neige zum Grübeln und Zweifeln.", "Ich nehme leicht zu, auch wenn ich nicht viel esse.", "Ich brauche immer viel Bwegung, um mich richtig wohl zu fühlen."];
  export const antwortenFrage10 = ["Bei den meisten Gelegenheiten, schaue ich lieber nur zu als mitzumachen.", "Ich werde richtig wütend, wenn ich auf etwas warten muss.", "Wenn ich mich angegriffen fühle, reagiere ich oft heftig und aggressiv.", "Ich mache gern alles mit. Ich will kein Spielverderber sein.", "Ich bilde mir zwar meine eigene Meinung, halte mich aber meist damit zurück.", "Bei Entscheidungen richte ich mich gern nach der Meinung von Anderen."]; 

  export const handlungsbeschreibung11 = "Die Antwort, die am häufigsten zutrifft oder Sie am ehesten charackterisiert, bekommt ein + ."
  export const handlungsbeschreibung12 = "Die Antwort, die am seltensten zutrifft oder Ihrem typischen Verhalten am fernsten liegt, bekommt ein - ."
  export const handlungsbeschreibung13 = "Die Antwort, die leer bleibt, bekommt eine 0 (null)."
  export const handlungsbeschreibung14 = "Wenn Sie ein + ein - und eine 0 eingetragen haben, können Sie zur nächstenn Aufgabe übergehen."

  export const handlungsbeschreibung2 = "Haken sie die drei Aussagen an, die am besten auf Sie zutreffen (Kästchen anklicken/antippen)."